import React from 'react';
import { TextInput, Select, Group, Box } from '@mantine/core';
import Flag from "react-world-flags";

export function PhoneInputGroup({
  label,
  required,
  value,
  countryCode,
  onPhoneChange,
  onCountryChange,
  error,
  countryOptions,
  placeholder
}) {
  return (
    <Group grow align="flex-start" preventGrowOverflow={false} className="phone-input-group">
      <Box style={{ flex: '2'}}>
        <Select
          label="Código de área"
          value={countryCode}
          onChange={onCountryChange}
          data={countryOptions.map((option) => ({
            value: option.value,
            label: option.label,
            code: option.code
          }))}
          placeholder="Seleccionar"
          searchable
          required={required}
          styles={{
            input: {
              height: 36
            },
            item: {
              whiteSpace: 'nowrap',
              height: '36px'
            }
          }}
          renderOption={({ option }) => (
            <Group gap="xs" wrap="nowrap" style={{ minWidth: 0 }}>
              <Flag 
                code={option.code} 
                style={{ width: 20, height: 15, flexShrink: 0 }} 
              />
              <span style={{ 
                overflow: 'hidden', 
                textOverflow: 'ellipsis', 
                whiteSpace: 'nowrap' 
              }}>
                {option.label}
              </span>
            </Group>
          )}
        />
      </Box>
      <TextInput
        label={label}
        value={value}
        onChange={(e) => onPhoneChange(e.target.value)}
        error={error}
        required={required}
        placeholder={placeholder}
        style={{ flex: 3 }}
        styles={{
          input: {
            height: 36
          }
        }}
      />
    </Group>
  );
}

export default PhoneInputGroup;